import {button_filter, read_url_params} from '../functions/filters';
import {filterAlumni} from '../functions/filter-alumni';
import 'slick-carousel';
let slideshow = $('.slider');

export default {
  init() {
    read_url_params();
  },
  finalize() {
    button_filter();
    filterAlumni();

    slideshow.slick({
      centerMode: false,
      arrows: false,
      slidesToShow: 1,
    });


    $('.slider a').on('click touch', e => {
      e.stopPropagation();
    });

    $('.slide-next').click(function() {
      slideshow.slick('slickNext');
    });

    $('.slide-prev').click(function() {
      slideshow.slick('slickPrev');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js